module.exports = __webpack_public_path__ + "img/beyond-green-vineyard.811b1225.jpg";